import { NotificationService } from '../NotificationService';
import { ServiceNames } from '../ServiceRegistry';
import { NotificationServiceImplBase } from './NotificationServiceImplBase';

export class NotificationServiceImpl extends NotificationServiceImplBase implements NotificationService {
  public get serviceName(): string {
    return ServiceNames.Notification;
  }
}
